export default __webpack_public_path__ + "static/media/IMG_9938.31f4c885.jpg";